export default __webpack_public_path__ + "static/media/Person_Computer.6eb3cdea.svg";